var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2ZM16 3v4M8 3v4M4 11h16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM7 17.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM11 13.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM11 17.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM15 13.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM15 17.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1Z",
    fill: "currentColor"
  })));
};
export default SvgCalendar;